import { useEffect, useState, useMemo } from "preact/hooks";
import localizedData from "../localizedData";
import { IMenuItem } from "./types";

const useMenuData = () => {
	const menuApiUri = useMemo( () => new URL( localizedData.menuApiUriData.data ), [] );

	const searchParams = new URLSearchParams( window.location.search );
	const customizeChangesetUuid = searchParams.get( 'customize_changeset_uuid' );

	if ( customizeChangesetUuid ) {
		menuApiUri.searchParams.append( 'customize_changeset_uuid', customizeChangesetUuid );
	}

	const [ menuData, setMenuData ] = useState<IMenuItem[]>();
	const [ error, setError ] = useState<string | null>( null );

	useEffect( () => {
		const fetchDataFromAPI = async () => {
			const apiResponse = await fetch( menuApiUri );

			if ( apiResponse.ok ) {
				return await apiResponse.json() as IMenuItem[];
			}

			throw new Error( `HTTP error! status: ${apiResponse.status}` );
		};

		const retrieveMenuData = async () => {
			try {
				const menuDataFromAPI = await fetchDataFromAPI();
				setMenuData( menuDataFromAPI );
			} catch ( menuDataError ) {
				setError( menuDataError.message );
			}
		};

		retrieveMenuData();
	}, [ menuApiUri ] );

	return { menuData, setMenuData, error };
};

export default useMenuData;
